import { render, staticRenderFns } from "./NewInfo.vue?vue&type=template&id=56efe865&scoped=true&"
import script from "./NewInfo.vue?vue&type=script&lang=js&"
export * from "./NewInfo.vue?vue&type=script&lang=js&"
import style0 from "./NewInfo.vue?vue&type=style&index=0&id=56efe865&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56efe865",
  null
  
)

export default component.exports